<div *ngIf="notifications.length">
    <cms-notification
            *ngFor="let notification of notifications"
            [notification]="notification">
    </cms-notification>
</div>